import React from "react";

import { useRouter } from "next/router";

import { Button } from "components/button";
import { Card } from "components/card";
import { Heading } from "components/heading";
import { Modal } from "components/modal";

interface ContinueApplicationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ContinueApplicationModal: React.FC<React.PropsWithChildren<Readonly<ContinueApplicationModalProps>>> = ({
  isOpen,
  onClose,
}) => {
  const router = useRouter();

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} closeOnOutsideClick showCloseButton>
      <Card>
        <Card.Header className="text-center">
          <Heading size={4} className="font-medium" text="Continue an application" />
        </Card.Header>
        <Card.Body className="text-center">
          <p className="max-w-xs m-auto text-md text-od-light-neutral">
            If you want to continue with your application, we need to verify the email used previously:
          </p>
          <Button className="mt-5" link={`/api/auth/login?returnTo=${router.asPath}/continue`} label="Verify email" />
        </Card.Body>
      </Card>
    </Modal>
  );
};
